import { createContext, useContext, useEffect, useState } from 'react'
import { Geocontext } from '../types'
import { useGeocontexts } from '../hooks/geocontext'
import { useAuthUser } from 'use-eazy-auth'

interface ContextTop {
  geoPermission?: string
  geocontexts: Geocontext[]
  isLoading?: boolean
}

const TopStateContext = createContext<ContextTop>({
  geocontexts: [],
})

export function TopContextProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const {
    data: geocontexts,
    isLoading,
    refetch: refetchGeocontexts,
  } = useGeocontexts()
  const { user } = useAuthUser()

  useEffect(() => {
    refetchGeocontexts()
  }, [user, refetchGeocontexts])

  //geo perms
  const [geoPermission, setGeoPermission] = useState<string>('prompt')

  useEffect(() => {
    if (navigator?.permissions?.query) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((permissionStatus) => {
          setGeoPermission(permissionStatus.state)

          permissionStatus.onchange = () => {
            setGeoPermission(permissionStatus.state)
          }
        })
    } else {
      setGeoPermission('prompt')
    }
  }, [])

  return (
    <TopStateContext.Provider
      value={{
        geoPermission,
        geocontexts: geocontexts ?? [],
        isLoading,
      }}
    >
      {children}
    </TopStateContext.Provider>
  )
}

export function useTopContextState() {
  const filters = useContext(TopStateContext)
  return filters
}
